import {Card, CardHeader, Divider, Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import React, {useState} from 'react';
import {LoadingOverlay} from '../../../components/LoadingOverlay/LoadingOverlay';
import getOverpaidBillingParties from './getOverpaidBillingParties.api';
import Results from './Results';
import {BillingParty} from '../../../graphql/billing_party.datatypes';

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        marginTop: theme.spacing(3),
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    content: {
        padding: 0
    },
}));

export const BillingPartyListContent = (props: {
    groupId?: number,
    groupRef?: string,
    bookingId?: number,
    isAdmin: boolean,
    canEdit: boolean,
    selectedBillingParty?: BillingParty,
    setSelectedBillingParty?: (party: BillingParty) => void,
}) => {
    const {isAdmin, canEdit, groupRef, selectedBillingParty, setSelectedBillingParty} = props;
    const classes = useStyles();

    const billingPartiesData = getOverpaidBillingParties();
    const overPaidBillingParties = billingPartiesData.data && billingPartiesData.data.overpaidBillingParties;

    return (
        <React.Fragment>
            <LoadingOverlay loading={billingPartiesData.loading}>
                {overPaidBillingParties && (
                    <Results
                        className={classes.content}
                        billingParties={overPaidBillingParties}
                        selectedBillingParty={selectedBillingParty}
                        setSelectedBillingParty={setSelectedBillingParty}
                        isAdmin={isAdmin}
                        canEdit={canEdit}
                    />
                )}
            </LoadingOverlay>
        </React.Fragment>
    );
};

const BillingPartyList = () => {
    const classes = useStyles();

    return (
        <Card className={classes.container}>
            <CardHeader title="Billing Parties that have Overpaid"/>
            <Divider/>
            <BillingPartyListContent isAdmin={true} canEdit={true}/>
        </Card>
    );
};

export default BillingPartyList;
